const RenderIfComponent = ({children,isValid}) => {
    return (isValid ? children : null)
}
export default RenderIfComponent